<div class="modal-content m-0">
  <div class="modal-header">
    <p class="mb-0">{{ 'pii.reportGenerator.title' | translate }}</p>
    <i class="fa-light fa-xmark ms-auto cursor-pointer" (click)="dismiss()"></i>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-12">
        <div class="row">
          <div class="form-group col-sm-12">
            <form class="ps-4 pe-4" [formGroup]="form" novalidate>
              <div class="row align-items-center">
                <label
                  for="reportType"
                  class="label col-sm-2 form-control-label mb-0"
                  >{{ 'pii.reportGenerator.reportType' | translate }}</label
                >
                <div class="col-sm-10 form-group">
                  <app-select
                    id="reportType"
                    formControlName="reportType"
                    data-cy="reportType-select"
                    [placeholder]="
                      'pii.reportGenerator.selectCustomReportType' | translate
                    "
                  >
                    @for (
                      customReportType of CustomReportTypes;
                      track customReportType
                    ) {
                      <app-select-option
                        [value]="customReportType"
                        [label]="
                          'pii.reportGenerator.reportTypes.' + customReportType
                            | translate
                        "
                      />
                    }
                  </app-select>
                </div>
              </div>
              @if (reportReason$ | async; as reportReason) {
                @if (reportReason.reasonRequired) {
                  <div class="row align-items-center form-group">
                    <label
                      for="reportReason"
                      class="label col-sm-2 form-control-label mb-0"
                      >{{
                        'pii.reportGenerator.reportReason' | translate
                      }}</label
                    >
                    <div class="col-sm-10">
                      <app-select
                        formControlName="reportReason"
                        id="reportReason"
                        data-cy="reportReason-select"
                        [placeholder]="
                          'pii.reportGenerator.reportReasonPlaceholder'
                            | translate
                        "
                      >
                        @for (reason of reportReason.reasons; track $index) {
                          <app-select-option
                            [value]="reason"
                            [label]="
                              'pii.reportGenerator.reason.' +
                                reason.toLowerCase() | translate
                            "
                          />
                        }
                      </app-select>
                    </div>
                  </div>
                }
                @if (!reportReason.reasonRequired) {
                  <div class="row align-items-center form-group">
                    <label
                      for="signeeId"
                      class="label col-sm-2 form-control-label mb-0"
                      >{{ 'common.signee' | translate }}</label
                    >
                    <div class="col-sm-10">
                      <app-select
                        id="signeeId"
                        data-cy="signee-select"
                        [placeholder]="'Select person'"
                        formControlName="signeeId"
                      >
                        @for (signee of signees(); track signee.id) {
                          <app-select-option
                            [value]="signee.id"
                            [label]="signee.name"
                          />
                        }
                      </app-select>
                    </div>
                  </div>
                }
              }

              <div class="row align-items-center form-group">
                <label
                  for="languageId"
                  class="label col-sm-2 form-control-label mb-0"
                  >{{ 'pii.reportGenerator.language' | translate }}</label
                >
                <div class="col-sm-10">
                  <app-select
                    id="languageId"
                    data-cy="language-select"
                    [placeholder]="'Select language'"
                    formControlName="languageId"
                  >
                    @for (language of languages(); track language.id) {
                      <app-select-option
                        [value]="language.id"
                        [label]="language.name"
                      />
                    }
                  </app-select>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button
      class="btn btn-primary"
      data-cy="generateReports-btn"
      [disabled]="form.invalid || loading()"
      (click)="generate()"
    >
      @if (loading()) {
        <span class="spinner-border spinner-border-sm"></span>
      }
      {{ 'pii.buttons.generateReports' | translate }}
    </button>
  </div>
</div>
